import { Component, ChangeDetectionStrategy, Renderer2, Inject, Input } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { MobileApp } from 'app/modules/main/models/mobile-apps';
import { map, tap } from 'rxjs/operators';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { chunk } from 'lodash';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mobile-apps-block',
  templateUrl: './mobile-apps-block.component.html',
  styleUrls: ['./mobile-apps-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileAppsBlockComponent {
  @Input() public popularApps: MobileApp[] = [];

  public icons = CustomIcons;
  public isMobileMenuOpen = false;
  public language = 'ru-RU';

  public breakPointObserve$ = this.breakpointObserver.observe(['(max-width: 948px)', '(max-width: 400px)']).pipe(
    map((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 400px)']) return 400;
      if (state.breakpoints['(max-width: 948px)']) return 948;
      return 0;
    })
  );

  public appsSlides$ = this.breakPointObserve$.pipe(
    map((screenWidth: number) => {
      let slideSize = 6;
      if (screenWidth === 1024) slideSize = 5;
      return chunk(this.popularApps, slideSize);
    })
  );

  public onLangChange$ = this.translateService.onLangChange.pipe(tap(value => (this.language = value.lang)));

  constructor(
    private breakpointObserver: BreakpointObserver,
    private r2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private translateService: TranslateService
  ) {}

  public toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;

    if (this.isMobileMenuOpen) {
      this.r2.addClass(this.document.body, 'no-scroll');
    } else {
      this.r2.removeClass(this.document.body, 'no-scroll');
    }
  }
}
